import { loadTealium } from './loadTealium';
import { getEnvironmentVariables } from './getEnvironmentVariables';
import { getConfiguration } from './getConfiguration';
import { loadClickstream } from './loadClickstream';
import { loadGoogleAnalytics } from './loadGoogleAnalytics';
import { loadPerimeterX } from './loadPerimeterX';

const envVariables = getEnvironmentVariables();
const { platform, brand } = envVariables;

window.ghsConfiguration = {
  ...envVariables,
  ...getConfiguration(envVariables),
} as AppConfig;

// This is an intentional console.log, to note in the console what our platform
// and brand are.
//
console.log(`Espresso Hybrid - ${platform}: ${brand.toLowerCase()}`);

loadClickstream();
loadGoogleAnalytics();
loadTealium();
loadPerimeterX();
